import { WidgetProps } from '@rjsf/utils';
import IconButton from '@mui/material/IconButton';
import { Restore } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import useDialog from 'hooks/useDialog';
import NodeOutputDialog from 'views/flow/canvas/NodeOutputDialog';
import ResizableTextarea from './ResizableTextarea';
import { useState } from 'react';
import PromptInputExecutionSelectDialog, { ExecutedNodeData } from 'components/dialog/PromptInputExecutionSelectDialog';
import { useParams } from 'react-router';

type PromptTestCaseInputWidgetOptions = {
  promptId?: string;
};

const PromptTestCaseInputWidget = (props: WidgetProps<PromptTestCaseInputWidgetOptions>) => {
  const { workflowId } = useParams();
  const { promptId } = props.options as PromptTestCaseInputWidgetOptions;
  const [nodeData, setNodeData] = useState<ExecutedNodeData | null>(null);
  const [showNodeOutput, OutputDialog] = useDialog(NodeOutputDialog);
  const [showExecutionSelect, ExecutionSelectDialog] = useDialog(PromptInputExecutionSelectDialog);

  const enabled = promptId && workflowId;

  const handleSetNodeData = (data: ExecutedNodeData) => {
    setNodeData(data);
    showNodeOutput(true);
  };

  const handleSubmit = (value: string) => {
    props.onChange(value);
    showNodeOutput(false);
    showExecutionSelect(false);
  };

  return (
    <>
      <div className="flex w-100 flex-row items-center gap-2">
        <ResizableTextarea {...props} options={{ rows: 3 }} />
        <Tooltip
          title={
            enabled
              ? 'Load results from previous Workflow Execution'
              : 'Available only in Workflow context where this prompt was used in an execution'
          }
        >
          <span>
            <IconButton onClick={() => showExecutionSelect(true)} color="primary" disabled={!enabled}>
              <Restore />
            </IconButton>
          </span>
        </Tooltip>
      </div>
      {nodeData && (
        <OutputDialog
          node={nodeData.node}
          onClose={() => showNodeOutput(false)}
          workflowExecutionId={nodeData.workflowExecutionId}
          onValueSelect={handleSubmit}
        />
      )}
      {enabled && (
        <ExecutionSelectDialog
          onClose={() => showExecutionSelect(false)}
          // @ts-expect-error: incompatible onSubmit args
          onSubmit={handleSetNodeData}
          promptId={promptId}
          workflowId={workflowId}
        />
      )}
    </>
  );
};
export default PromptTestCaseInputWidget;
